function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import intlShape from 'shapes/intlShape';
import { formatDate } from 'helpers/datetime';
import { getFromReadings, getFromGlucoseLevelDistribution } from 'components/Charts/GlucoseLevelDistributionChart/helpers';
import messages from '../../../messages';
import styles from './GlucoseLevelDistributionBarChart.pcss';
var _React_PureComponent;
class GlucoseLevelDistributionBarChart extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { glucoseLevelDistribution, standards, readings, valueKey } = props;
        if (glucoseLevelDistribution && glucoseLevelDistribution !== state.glucoseLevelDistribution) {
            return getFromGlucoseLevelDistribution(glucoseLevelDistribution);
        }
        if (readings && readings !== state.readings) {
            return getFromReadings(readings, valueKey, standards);
        }
        return null;
    }
    renderHighBar(highRatio) {
        if (!highRatio) return null;
        const { size } = this.props;
        const styleHigh = {
            height: size * highRatio || 0,
            background: this.chartColors[0],
            width: 130,
            fontSize: size / 9,
            justifyContent: 'start'
        };
        return /*#__PURE__*/ _jsx("div", {
            className: styles.glucoseLevel__barWrapper__label,
            style: styleHigh,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.bloodGlucoseAbove))
        });
    }
    renderLowBar(lowRatio) {
        if (!lowRatio) return null;
        const { size } = this.props;
        const styleLow = {
            height: size * lowRatio || 0,
            background: this.chartColors[2],
            width: 130,
            fontSize: size / 9,
            justifyContent: 'end'
        };
        return /*#__PURE__*/ _jsx("div", {
            className: styles.glucoseLevel__barWrapper__label,
            style: styleLow,
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseReport.bloodGlucoseBelow))
        });
    }
    renderEmptyBar(total) {
        if (total !== 0) return null;
        const { size } = this.props;
        const styleEmpty = {
            height: size,
            background: this.chartColors[3],
            width: 130,
            borderRadius: 0
        };
        return /*#__PURE__*/ _jsx("div", {
            className: styles.glucoseLevel__barWrapper__part,
            style: styleEmpty
        });
    }
    renderTargetBarText(targetRatio, total, totalTarget) {
        const targetPercentage = (targetRatio * 100).toFixed(0);
        if (targetPercentage <= 25) {
            return /*#__PURE__*/ _jsx("p", {
                style: {
                    fontSize: 13,
                    fontWeight: 300,
                    lineHeight: '17px',
                    textTransform: 'uppercase'
                }
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    style: {
                        fontSize: 27,
                        fontWeight: 800,
                        lineHeight: '36px'
                    },
                    children: `${targetPercentage}%`
                }),
                /*#__PURE__*/ _jsx("p", {
                    style: {
                        fontSize: 13,
                        fontWeight: 300,
                        lineHeight: '17px',
                        textTransform: 'uppercase'
                    },
                    children: this.props.intl.formatMessage(messages.glucoseReport.correctRange)
                }),
                /*#__PURE__*/ _jsx("p", {
                    style: {
                        fontSize: 10,
                        fontWeight: 800,
                        lineHeight: '13px'
                    },
                    children: `(${totalTarget}/${total} ${this.props.intl.formatMessage(messages.glucoseReport.readings)})`
                })
            ]
        });
    }
    renderTargetTextBelowBars(targetRatio, total, totalTarget) {
        const targetPercentage = (targetRatio * 100).toFixed(0);
        if (targetPercentage > 25) return null;
        const targetValue = targetPercentage !== 'NaN' ? /*#__PURE__*/ _jsxs("div", {
            children: [
                `${Math.round(targetPercentage)}% `,
                " ",
                this.props.intl.formatMessage(messages.glucoseReport.correctRange)
            ]
        }) : null;
        return /*#__PURE__*/ _jsxs("p", {
            className: styles.glucoseLevel__textBelowBars,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: targetValue
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: `(${totalTarget}/${total} ${this.props.intl.formatMessage(messages.glucoseReport.readings)})`
                })
            ]
        });
    }
    renderTargetBar(targetRatio, total, totalTarget) {
        const { size } = this.props;
        const styleTarget = {
            height: size * targetRatio || 0,
            background: this.chartColors[1],
            width: 130,
            fontSize: size / 9
        };
        return /*#__PURE__*/ _jsx("div", {
            className: styles.glucoseLevel__barWrapper__part,
            style: styleTarget,
            children: this.renderTargetBarText(targetRatio, total, totalTarget)
        });
    }
    renderBars() {
        const totalLow = this.state.levels.preMeal.low + this.state.levels.postMeal.low;
        const totalTarget = this.state.levels.preMeal.target + this.state.levels.postMeal.target;
        const totalHigh = this.state.levels.preMeal.high + this.state.levels.postMeal.high;
        const total = totalLow + totalTarget + totalHigh;
        const lowRatio = totalLow / total;
        const targetRatio = totalTarget / total;
        const highRatio = totalHigh / total;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.glucoseLevel__barWrapper,
            children: [
                this.renderHighBar(highRatio),
                this.renderTargetBar(targetRatio, total, totalTarget),
                this.renderLowBar(lowRatio),
                this.renderEmptyBar(total),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.glucoseLevel__barWrapper__date,
                    children: `${formatDate(moment(this.props.start), 'MMMM D')} - ${formatDate(moment(this.props.end), 'MMMM D, YYYY')}`
                }),
                this.renderTargetTextBelowBars(targetRatio, total, totalTarget)
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            children: this.renderBars()
        });
    }
    constructor(props){
        super(props);
        this.state = {
            levels: {
                preMeal: {
                    high: 0,
                    target: 0,
                    low: 0
                },
                postMeal: {
                    high: 0,
                    target: 0,
                    low: 0
                }
            },
            glucoseLevelDistribution: null,
            readings: []
        };
        this.chartColors = [
            '#F3BA1A',
            '#19AA8E',
            '#EF384B',
            '#E8F7F4'
        ];
    }
}
_define_property(GlucoseLevelDistributionBarChart, "propTypes", {
    // Explicit props
    readings: PropTypes.array,
    valueKey: PropTypes.string,
    glucoseLevelDistribution: PropTypes.shape({
        highPostMeal: PropTypes.number,
        highPreMeal: PropTypes.number,
        lowPostMeal: PropTypes.number,
        lowPreMeal: PropTypes.number,
        targetPostMeal: PropTypes.number,
        targetPreMeal: PropTypes.number
    }),
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    isInProgress: PropTypes.bool,
    size: PropTypes.number,
    start: PropTypes.object,
    end: PropTypes.object,
    intl: intlShape.isRequired
});
_define_property(GlucoseLevelDistributionBarChart, "defaultProps", {
    size: 230
});
export default withStyles(styles)(injectIntl(GlucoseLevelDistributionBarChart));
